<div mdbTooltip="{{mdbTooltip}}" container="body" placement="bottom">
  <a [mdbPopover]="popTemplate" container="body" [outsideClick]="true" placement="bottom" [isOpen]="popoverOpen"
    (onShown)="onShown()" (onHidden)="onHidden()" class="nav-link waves-light" mdbWavesEffect>
    <span></span>
    <mdb-icon fas [icon]="faIcon" style="width:16px;height:16px;" [style.color]="files.length ? '#00659c' : 'green'">
    </mdb-icon>
    <mdb-badge color="orange" *ngIf="uploadCount">
      {{uploadCount}}
    </mdb-badge>
  </a>
</div>


<ng-template #popTemplate let-message="message">
  <div style="padding: 10px !important">
    <div class="row" *ngFor="let file of files">
      <div style="width: 300px">
        <div><strong mdbTooltip="{{file.name}}" placement="bottom" container="body">{{file.name | limitTo: 25}} </strong>
        </div>
        <div>
          <mdb-progress value="{{file.progress.data.percentage}}" min="0" max="100" [type]="checkStatus(file)"
            aria-valuenow="file.progress.data.percentage" aria-valuemin="0" aria-valuemax="100">
            {{file.progress.data.percentage}}</mdb-progress>
        </div>
      </div>
    </div>
    <div *ngIf="!files.length">
      {{ 'administration_noFilesInQueue_label' | translate }}
    </div>
  </div>
</ng-template>
